import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Col } from "reactstrap";
import { CustomButton } from "../../Common/Components/Button/CustomButton";
import { useTranslation } from "react-i18next";
import useApiCallService from "../../Common/Helpers/ApiCall";
import ResponseEconomicReportModel from "../Models/ResponseEconomicReportModel";
import { ADMIN_PATHS, ORGANIZATION_PATHS } from "../../config";
import { AccountRowView } from "../../DigitalAccount/Components/AccountRowView";
import { EconomicReportDetailsView } from "./EconomicReportDetailsView";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";

const OrganizationEconomicReportInfo = () => {
    const { ApiCall } = useApiCallService();
    const memoizedApiCall = useCallback(ApiCall, []);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = CheckMobile(998);
    const location = useLocation();
    const item = location.state?.item;
    const modelIdValue = location.state?.modelId;
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('economicReport.economicReportInfo'));
        setPageTitleKey('economicReport.economicReportInfo');
        setOnBack(handleBack);
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    const idValue = new URLSearchParams(window.location.search).get('id');
    const [economicReportData, setEconomicReportData] = useState(new ResponseEconomicReportModel());
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        const fetchEconomicReport = async () => {
            if (idValue && !hasFetched) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/export-data/admin/info-organization-economic-report?id=${idValue}`,
                    };
                    const handleApiResponse = (response) => {
                        setEconomicReportData(response);
                        setHasFetched(true);
                    };
                    await memoizedApiCall(apiCallOptions, handleApiResponse);
                } catch (error) {
                    console.error("Error fetching economic report details:", error);
                }
            }
        };

        fetchEconomicReport();
    }, [idValue, memoizedApiCall, hasFetched]);

    const handleBack = () => {
        navigate(ORGANIZATION_PATHS.ORGANIZATION_ECONOMIC_REPORT, {
            state: { cameFromInfo: true }
        });
    };

    return (
        <>
            {!isMobile && (
                <Col lg={1} className="px-0">
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'ms-3 mb-3'}
                        onClick={handleBack}
                    />
                </Col>
            )}

            {hasFetched && economicReportData !== null ? (
                <EconomicReportDetailsView data={economicReportData} modelId={modelIdValue} itemFromState={item} />
            ) : null}
        </>
    );
};

export default OrganizationEconomicReportInfo;